import { UPDATE_VALID_FORM_DATA, UPDATE_FROM_GETDATA } from "../actions"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialClaimData = {
  claimAttributeModel: {
    UpStatus: "",
    ContractClass: "",
    ContractType: "",
    PurchaseDt: "",
  },
  claimLiabilityDetail: {
    // claimantNricNumber: "",

    policyNumber: "",
    policyHolderName: "",
    policyHolderEmail: "",
    policyHolderTel: "",
    isOtherInsuranceCovering: false,
    otherInsurance: "",
    claimantIsPolicyHolder: true,
    claimantName: "",
    claimantEmail: "",
    claimantMobile: "",

    claimAmount: "",
    claimDetail: "",
    dateOfAccident: "",
    timeOfAccident: "",
    locationOfAccident: "",
    descriptionOfAccident: "",
    noticeDate: "",
    noticeTime: "",
    whoInform: "",
    writingNotice: false,
    actionTaken: "",
    prevention: "",
    liableForAccident: "",
    thirdPartyName: "",
    thirdPartyAddress: "",
    thirdPartyOccupation: "",
    thirdPartyOtherOccupation: "",
    employeeDo: "",
    allegedAgainst: "",

    // policyNumber: "L0002005",
    // policyHolderName: "Rachel",
    // policyHolderEmail: "XieBin.W@devops.etiqa.com.sg",
    // policyHolderTel: "98063015",
    // isOtherInsuranceCovering: true,
    // otherInsurance: "Other Insurance",
    // claimantName: "Claimant A",
    // claimantEmail: "XieBin.W@devops.etiqa.com.sg",
    // claimantMobile: "98063015",
    // claimAmount: "1,000.99",
    // claimDetail: "Detail of claim",
    // dateOfAccident: "2020-05-07T04:00:00.000Z",
    // timeOfAccident: "07:07",
    // locationOfAccident: "Location of accident",
    // descriptionOfAccident: "Description of Accident",
    // noticeDate: "2020-05-06T04:00:00.000Z",
    // noticeTime: "07:07",
    // whoInform: "Whom did",
    // writingNotice: false,
    // actionTaken: "desc in detail",
    // prevention: "prevent",
    // liableForAccident: "opinion",
    // thirdPartyName: "",
    // thirdPartyAddress: "",
    // thirdPartyOccupation: "",
    // thirdPartyOtherOccupation: "",
    // employeeDo: "",
    // allegedAgainst: "",

    witnessName: "",
    witnessAddress: "",

    declaration: false,
    sourceSystem: "Web",
  },
  claimLiabilityWitnessList: [],
  claimPayoutModel: {
    payoutType: "Direct Credit",
    bankBIC: "",
    bankName: "",
    accountNumber: "",
    accountName: "",
  },
  claimAttribute: {
    upStatus: "",
    contractClass: "",
    contractType: "",
    purchaseDt: "",
  },
}

const claimDataReducer = (state = initialClaimData, action) => {
  const newState = Object.assign({}, state)

  switch (action.type) {
    case UPDATE_VALID_FORM_DATA:
      newState[action.targetModal] = Object.assign(
        newState[action.targetModal],
        action.newData
      )
      return newState
    case UPDATE_FROM_GETDATA:
      if (
        typeof newState["claimLiabilityDetail"][action.targetModal] ==
        "undefined"
      ) {
        newState["claimLiabilityDetail"] = {}
        newState["claimLiabilityDetail"][action.targetModal] = action.newData
      } else {
        newState["claimLiabilityDetail"][action.targetModal] = action.newData
      }

      return newState
    default:
      return newState
  }
}

export default claimDataReducer
